export const DETALIZATION_MODAL_GETTING_DETAIL_OPTIONS = {
  DOWNLOAD: 'Скачать на компьютер',
  SEND_ON_EMAIL: 'Отправить по e-mail',
};

export const DETALIZATION_MODAL_DOWNLOAD_OPTIONS = {
  pdf: 'PDF',
  xls: 'XLSX',
  xls03: 'XLS',
};

export const IMAGE_DATA = {
  src: '//static.beeline.ru/upload/images/detalization/party-popper.svg',
  alt: 'Успех',
  lazy: false,
};

export const DETALIZATION_CALENDAR = {
  CALENDAR_TITLE: 'Расходы за',
  DATA_TITLE: 'Статистика интернет-трафика за',
  CALL_TITLE: 'Статистика звонков за ',
  SMS_TITLE: 'Статистика сообщений за',
  DATA_ROAMING_TITLE: 'Статистика интернет-трафика в роуминге за',
  CALL_ROAMING_TITLE: 'Статистика звонков в роуминге за ',
  SMS_ROAMING_TITLE: 'Статистика сообщений в роуминге за',
  REPORT_BUTTON_TEXT: 'Составить отчет',
  ERROR_PERIOD_MESSAGE: 'Выгрузить детализацию за такой большой период нельзя. Установите срок в месяц и выгрузите детализацию за последние полгода помесячно.',
};

export const DETALIZATION_MODAL_COMMON = {
  REPORT_CONFIRM: 'Отчёт приходит за последний месяц с выбранной даты',
  REPORT_SUCCESS: 'Вы настроили ежемесячную отправку детализации.',
  ERROR_DATE_MASSAGE: 'Выгрузить детализацию за такой большой период нельзя. Установите срок в месяц и выгрузите детализацию за последние полгода помесячно.',
  INFO_MASSAGE: 'Детализацию за 7 и более месяцев можно получить в офисе',
  MAIL_INFO_MASSAGE: 'Адрес также будет отображаться в личном кабинете и будет использован для восстановления пароля',
  PASSCODE_INFO_MASSAGE: 'Введите код подтверждения, который мы отправили вам на ',
  DETALIZATION_CAPTION: 'Получение детализации',
  MAIL_CAPTION: 'Редактировать почту',
  PASSCODE_CAPTION: 'Подтвердить почтовый адрес',
  DETALIZATION_PERIOD: 'Выберите период',
  CHANGE_MAIL_BUTTON_CAPTION: 'Изменить почту',
  ERROR_TRY_AGAIN: 'Произошла ошибка попробуйте ещё раз',
  FORMAT: 'Формат',
  REGULAR_DETALIZATION_REPORT_CAPTION: 'Ежемесячная отправка детализации',
  SEND_REPORT_FOR_CTNS: 'Присылать отчёты для номеров',
  SEND_REPORT_FOR_CTN: 'Присылать отчеты для номера',
  SEND_BY_EMAIL: 'По эл. почте',
  REPORTING_PERIOD: 'Отчетный период',
};

export const ANALYTICS_DETAIL = {
  CLICK_ON_NAVIGATION: 'tap_so_detail',
  OPEN_SPEND_PAGE: 'so_detail_spend',
  SPEND_TYPE_CLICK: 'so_detail_spend_type',
  CATEGORY_FILTER: 'tap_so_detail_spend_filter',
  REPLENISH_CLICK: 'so_detail_topup',
  PERIOD_CHANGE: 'tap_so_detail_date_period',
  PERIOD_CHOOSE: 'so_detail_date_period_change',
  SEND_DETAIL: 'tap_so_detail_send',
  DOWNLOAD_DETAIL: 'tap_so_detail_send_down',
  SEND_FORM_DETAIL: 'tap_so_detail_send_down_form',
  SUCCESS_DOWNLOAD: 'so_detail_send_down_done',
  SEND_MAIL_DETAIL: 'tap_so_detail_send_mail',
  MAIL_DETAIL_SEND_FORM: 'tap_so_detail_send_mail_form',
  SUCCESS_MAIL_SEND: 'so_detail_send_mail_done',
  SEND_REGULAR_DETAIL: 'tap_so_detail_send_reg',
  REGULAR_DETAIL_SEND_FORM: 'tap_so_detail_send_reg_form',
  SUCCESS_REGULAR_DETAIL: 'so_detail_send_reg_done',
};
